import styled from "@emotion/styled";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

export const PaginationBar = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 18px 18px;
  border-radius: 12px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 14px 12px;
    gap: 10px;
    flex-wrap: wrap;
  }
`;

export const PaginationLeft = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 100%;
    justify-content: flex-start;
  }
`;

export const PaginationRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 100%;
    justify-content: flex-end;
  }
`;

export const PageSizeSelect = styled.select`
  background: transparent;
  color: ${({ theme }) => theme.colors.text.primary};
  border: none;
  outline: none;
  font-size: ${({ theme }) => theme.fontSizes.medium};
  font-weight: ${({ theme }) => theme.fontWeight.medium || 500};
  cursor: pointer;
  padding: 6px 6px;
  border-radius: 8px;
  appearance: auto;

  option {
    background-color: #3A3A3F; /* Dark background */
    color: #ffffff; /* White text */
    padding: 5px 10px; /* Padding around text */
    border-radius: 5px; /* Rounded corners */
    font-size: ${({ theme }) => theme.fontSizes.xmedium};
    cursor: pointer; /* Pointer cursor on hover */
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: auto;
  }
`;

export const PageAmountText = styled.span`
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: ${({ theme }) => theme.fontSizes.medium};
  opacity: 0.9;
  white-space: nowrap;
  min-width: 0;
`;

export const NavIconButton = styled.button`
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: 1px solid rgba(128, 149, 183, 0.18);
  background: rgba(255, 255, 255, 0.04);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;

  svg {
    width: 18px;
    height: 18px;
    color: ${({ theme }) => theme.colors.text.primary};
    opacity: 0.9;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.07);
  }

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }
`;

export const ChevronLeftIcon = styled(ChevronLeft)``;
export const ChevronRightIcon = styled(ChevronRight)``;
